import { mapSelectObjectsToValue,mapSelectObjectsToCommaSepratedValue } from "services";
import { timeAgo, toApiDateTimeFormat } from "services/date.service";
import { formatNumberToMoneyWithCurrencySymbol } from "services/money.service";
import * as moment from "moment";

export const dateTimeRequest = {
  startDateTime: {
    transform: ({ src }) => {
      if (!src?.dateRange?.[0]) return toApiDateTimeFormat(moment().startOf("day"));
      return toApiDateTimeFormat(src?.dateRange?.[0]);
    },
  },
  endDateTime: {
    transform: ({ src }) => {
      if (!src?.dateRange?.[1]) return toApiDateTimeFormat(moment().endOf("day"));
      return toApiDateTimeFormat(src?.dateRange?.[1], true);
    },
  },
};


export const eventBookingDateTimeRequest = {
  startDateTime: {
    transform: ({ src }) => {
      const timezone = src?.timezone || moment.tz.guess();
      const baseDate = src?.dateRange?.[0] || moment().startOf("day");
      const zonedDate = moment.tz(baseDate.format(), timezone);
      return toApiDateTimeFormat(zonedDate);
    },
  },
  endDateTime: {
    transform: ({ src }) => {
      const timezone = src?.timezone || moment.tz.guess();
      const baseDate = src?.dateRange?.[1] || moment().endOf("day");
      const zonedDate = moment.tz(baseDate.format(), timezone);
      return toApiDateTimeFormat(zonedDate, true);
    },
  },
};

export const filterRequest = {
  venueId: { key: "venueId" },
  page: { key: "page" },
  pageSize: { key: "pageSize" },
  searchKey: { key: "searchKey" },
};

export const selectToObjectRequest = (key) => {
  return {
    transform: ({ self }) => {
      return mapSelectObjectsToValue(self);
    },
    key,
  };
};


export const selectToObjectCommaSepratedRequest = (key) => {
  return {
    transform: ({ self }) => {
      return mapSelectObjectsToCommaSepratedValue(self);
    },
    key,
  };
};

export const dateToTimeAgo = (key) => {
  return {
    transform: ({ self }) => {
      if (self === "Totals") {
        return "Totals";
      }
      if (!self) {
        return null;
      }
      return timeAgo(self, true);
    },
    key,
  };
};

export const getCurrentTimeWithTimezone = () => {
  return moment().format(moment.HTML5_FMT.DATETIME_LOCAL_MS + "ZZ");
};

// Shared by reservation.mapper.js and transaction.mapper.js -- both need to enrich a bill
// split's items_snapshot (raw JSON, itemId/quantity/amount only, no product name) against
// the same reservation/transaction's own orders[].items[] (which does have productName).

// itemLocalId -> order item.
export const buildItemLookup = (orders = []) => {
  const lookup = {};
  orders.forEach((order) => {
    (order.items || []).forEach((item) => {
      lookup[item.itemLocalId] = item;
    });
  });
  return lookup;
};

export const parseItemsSnapshot = (itemsSnapshot) => {
  if (!itemsSnapshot) {
    return [];
  }
  try {
    const parsed = JSON.parse(itemsSnapshot);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
};

// items_snapshot is serialized processor-side via System.Text.Json.JsonSerializer
// .Serialize(split.Items) with no naming-policy options, so it's PascalCase
// (ItemId/Quantity/Amount), not camelCase -- read both so this stays correct if that
// ever changes.
export const mapSplitItems = (itemsSnapshot, itemLookup) =>
  parseItemsSnapshot(itemsSnapshot).map((snapshotItem) => {
    const itemId = snapshotItem.itemId ?? snapshotItem.ItemId;
    const quantity = snapshotItem.quantity ?? snapshotItem.Quantity;
    const amount = snapshotItem.amount ?? snapshotItem.Amount;
    const item = itemLookup[itemId] || {};
    return {
      itemId,
      productName: item.productName || itemId,
      quantity,
      amount: formatNumberToMoneyWithCurrencySymbol(amount || 0),
    };
  });
